export const paramsKey = (key: string | undefined) => {
  switch (key) {
    case 'Status':
      return 'status.list';
    case 'Component type':
      return 'component_type_id.list';
    case 'Channel type':
      return 'layout_type_id.list';
    case 'Screen configuration':
      return 'locationGroups.channel_name.list';
    case 'Region':
      return 'hq.region.list';
    case 'Locations':
      return 'locationGroups.id.null';
    case 'Product category':
      return 'product_category_id';
    case 'Variation types':
      return 'product_variation_size_id.list';
    case 'Zone':
      return 'zone.list';
    case 'Subzone':
    case 'Sub-zone':
    case 'Sub zone':
      return 'subzone.list';
    case 'City':
      return 'city.list';
    case 'Zip/Postal code':
      return 'zip.list';
    case 'Country':
      return 'country.list';
    case 'Timezone':
      return 'hq.timezone.list';
    case 'User':
      return 'user.regexp';
    case 'Operation':
      return 'operation.list';
    case 'Collection':
      return 'collection.list';
    case 'Role':
      return 'role.list';
    case 'Date range':
      return 'timestamp.from|timestamp.to';
    case 'Overrides':
      return 'Overrides';
    case 'Location tags':
      return 'location_tag_id.list';
    case 'Component tags':
      return 'component_tag_id';
    case 'Assembly tags':
    case 'Assembly tag':
      return 'assembly_tag_id';
    case 'Owner Operator tags':
    case 'Owner/Operator tags':
      return 'location_owner_tag_id.list';
    case 'product_variation_size_id':
      return 'productVariations.product_variation_size_id.list';
    case 'active':
      return 'active.list';
    case 'Components':
      return 'has_assigned_component';
    case 'Product code':
      return 'productVariations.product_code.list';
    case 'Flavor':
      return 'product_variation_flavors.list';
    case 'product_variation_flavor_id':
      return 'productVariations.product_variation_flavor_id.list';
    case 'product_code':
      return 'productVariations.product_code.regexp';
    case 'product_name':
      return 'productVariations.name.regexp';
    case 'flavor_name':
      return 'product_variation_flavors.regexp';
    case 'Layout type':
      return 'layout_type_id.list';
    case 'Number of screens':
      return 'num_screens.list';
    case 'Screen orientation':
      return 'orientation.list';
    case 'Advanced settings':
      return 'advanced_settings.list';
    case 'Advanced filters':
      return 'layout_tag_id';
    case 'channel_name':
      return 'channel_name.regexp';
    case 'publication_status':
      return 'hq.publication_status.list';
    case 'time_zone':
      return 'hq.timezone.list';
    case 'date_range':
      return 'hq.requested_publication_stamp.from|hq.requested_publication_stamp.to';
    case 'Staged':
      return 'bulk_replace';
    case 'Expired':
      return 'is_assembly_expired';
    case 'date_created':
      return 'created_at.from|created_at.to';
    case 'date_modified':
      return 'modified_at.from|modified_at.to';
    case 'location_tags':
      return 'location_tag_id';
    case 'location_owner_tags':
      return 'location_owner_tag_id';
    case 'Owner/Operator permissions':
      return 'usable_as_override';
    case 'store_number':
      return 'store_number.regexp';
    case 'DY templates':
      return 'template_type';
    default:
      return '';
  }
};
